// import { get } from "lodash";
import _ from "lodash";
import { dedaultBudgetOptions } from "src/components/fillter/components/filter-budge/types";
import { IMetadataItem, IMetaItemDynamoDb } from "src/interfaces";
interface IZone {
  m_key: string;
  sort: string;
  text_value: string;
}

interface IArea {
  m_key: string;
  sort: string;
  text_value: string;
  root_path: string;
  area_sort: number;
}

interface ICity {
  m_key: string;
  sort: string;
  text_value: string;
  root_path: string;
  parent_path: string;
}

interface IData {
  [key: string]: any;
}

function buildZoneAreaCity(data: IData) {
  let zone_obj: any = {};
  (data.zone || []).forEach((z: IZone) => {
    zone_obj[z.sort] = {
      ...z,
      areas: [],
    };
  });

  let area_obj: any = {};
  (data.area || []).forEach((a: IArea) => {
    area_obj[a.sort] = { ...a, citys: [] };
  });

  let city_obj: any = {};
  (data.city || []).forEach((c: ICity) => {
    city_obj[c.sort] = { ...c };
    if (area_obj[c.parent_path]) {
      area_obj[c.parent_path]["citys"].push(c);
      area_obj[c.parent_path]["citys"] = _.sortBy(
        area_obj[c.parent_path]["citys"],
        ["city_order"]
      );
    }
  });

  (data.area || []).forEach((a: IArea) => {
    if (zone_obj[a.root_path]) {
      zone_obj[a.root_path]["areas"].push(area_obj[a.sort]);
      zone_obj[a.root_path]["areas"] = _.sortBy(
        zone_obj[a.root_path]["areas"],
        ["area_sort"]
      );
    }
  });

  return {
    ...data,
    list_mapped: (Object.values(zone_obj) || []).sort(
      (a: any, b: any) => a.order - b.order
    ),
    area_obj,
    zone_obj,
    city_obj,
  };
}

function handleMappingZoneAreaCitySearch(
  zone_obj: { [key: string]: any } = {},
  area_obj: { [key: string]: any } = {},
  list_result_search = []
) {
  /**
   * start search
   */
  let search_zone_obj: any = {};
  let search_area_obj: any = {};

  list_result_search.forEach((result: IMetadataItem) => {
    if (result["m_key"] === "zone") {
      search_zone_obj[result["sort"]] = { ...result, nodes: [] };
    }
    if (result["m_key"] === "area") {
      search_area_obj[result["sort"]] = { ...result, nodes: [] };
    }
  });

  //mapping city to area
  list_result_search.forEach((city: any) => {
    if (city["m_key"] === "city") {
      if (search_area_obj[city["parent_path"]]) {
        search_area_obj[city["parent_path"]]["nodes"].push(city);
      } else {
        if (area_obj[city["parent_path"]]) {
          let areaOrigin = { ...area_obj[city["parent_path"]] };
          delete areaOrigin["citys"];

          search_area_obj[city["parent_path"]] = {
            ...areaOrigin,
            nodes: [{ ...city }],
          };
        }
      }
    }
  });

  // // if area no have city ---> get full city
  // Object.keys(search_area_obj).forEach((key) => {
  //   let area = search_area_obj[key];
  //   if (area.nodes.length === 0 && get(area_obj[key], "citys", []).length > 0) {
  //     search_area_obj[key]["nodes"] = get(area_obj[key], "citys", []);
  //   }
  // });

  // map area to zone
  Object.keys(search_area_obj).forEach((key) => {
    let area = search_area_obj[key];
    if (search_zone_obj[area["root_path"]]) {
      search_zone_obj[area["root_path"]]["nodes"] = [
        ...search_zone_obj[area["root_path"]]["nodes"],
        { ...area },
      ];
    } else if (zone_obj[area["root_path"]]) {
      search_zone_obj[area["root_path"]] = {
        ...zone_obj[area["root_path"]],
        nodes: [search_area_obj[key]],
      };
    }
  });

  // // if zone no have area --> get full area not citys
  // Object.keys(search_zone_obj).forEach((key) => {
  //   let zone = search_zone_obj[key];
  //   if (zone.nodes.length === 0 && get(zone_obj[key], "areas", []).length > 0) {
  //     search_zone_obj[key]["nodes"] = [...get(zone_obj[key], "areas", [])].map(
  //       (ele: any) => ({ ...ele, citys: [] })
  //     );
  //   }
  // });

  return Object.values(search_zone_obj) || [];
}

function build_other_metadata_to_obj(metadata: IData) {
  const keys = [
    "station",
    "spots",
    "amenity",
    "hotel_info_facility",
    "hotel_type",
    "hotel_theme",
    "spring_type",
    "room_type",
    "bed_type",
    "bath_type",
    "popular_filters",
    "view",
    "late_checkout",
    "benifit",
    "service",
    "evalution",
    "hotel_info_pet",
    "hotel_info_special",
    "room_style",
    "smoking_type",
    "method_payment_support",
  ];

  metadata["evalution"] = (metadata["evalution"] || [])
    .map((itemObj: IMetaItemDynamoDb) => {
      let order = 1;
      let value = "9999999";
      if (itemObj["text_value_en"] === "★4.0 or higher") {
        order = 2;
        value = "4";
      }
      if (itemObj["text_value_en"] === "★4.5 or more") {
        order = 3;
        value = "4_5";
      }

      return { ...itemObj, order, value };
    })
    .sort((a: any, b: any) => a.order - b.order);

  Object.keys(metadata).forEach((key: string) => {
    if (keys.includes(key)) {
      const obj: { [key: string]: IMetaItemDynamoDb } = {};
      (metadata[key] || []).forEach((itemObj: IMetaItemDynamoDb) => {
        if (key === "evalution") {
          if (itemObj.value) {
            obj[itemObj.value] = { ...itemObj };
          }
        } else {
          obj[itemObj.sort] = { ...itemObj };
        }
      });
      metadata[`${key}_obj`] = obj;
    }
  });

  metadata["budget"] = dedaultBudgetOptions;
  metadata["hotel_detail_search_condition"] = metadata[
    "hotel_detail_search_condition"
  ].map((ele: any) => {
    return { ...ele, sort: ele.root_path, sort_origin: ele.sort };
  });

  metadata["hotel_detail_search_condition_group"] = {};
  if (metadata["hotel_detail_search_condition"]) {
    metadata["hotel_detail_search_condition_group"] = _.groupBy(
      metadata["hotel_detail_search_condition"],
      "group_key"
    );
  }

  let obj_search_room_plan_hotel_detail: any = {};
  (metadata["hotel_detail_checkbox"] || []).forEach((el: any) => {
    const key = el["root_path"].split("#")[0];
    obj_search_room_plan_hotel_detail[key] = 1;
  });
  (metadata["hotel_detail_search_condition"] || []).forEach((el: any) => {
    const key = el["root_path"].split("#")[0];
    obj_search_room_plan_hotel_detail[key] = 1;
  });
  metadata["list_filter_type_room_plan"] =
    Object.keys(obj_search_room_plan_hotel_detail) || [];

  // store popular_keywords to local storage
  localStorage.setItem(
    "popular_keywords",
    JSON.stringify(metadata["popular_keywords"])
  );

  return metadata;
}

export {
  build_other_metadata_to_obj,
  buildZoneAreaCity,
  handleMappingZoneAreaCitySearch,
};
